// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Confirmation dialog shared by the back-office pages (B-book, notifications) ===== */

.confirm_modal_overlay {
    --confirm-danger: #B91C1C; /* darker than --danger, so white text reaches 4.5:1 */
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
    background: rgba(15, 23, 42, 0.5);
    -webkit-backdrop-filter: blur(3px);
            backdrop-filter: blur(3px);
    animation: confirm_modal_fade 0.15s ease-out;
}

[data-theme="dark"] .confirm_modal_overlay {
    --confirm-danger: #F87171;
}

.confirm_modal {
    display: flex;
    gap: 16px;
    width: min(520px, 100%);
    padding: 24px;
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    animation: confirm_modal_pop 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}

.confirm_modal_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 50%;
    color: var(--primary);
    background-color: var(--primary-light);
}

.confirm_modal_icon_danger {
    color: var(--confirm-danger);
    background-color: var(--danger-light);
}

.confirm_modal_body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
}

.confirm_modal_body h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--text-primary);
}

.confirm_modal_body p {
    margin: 0;
    line-height: 1.55;
    color: var(--text-secondary);
}

.confirm_modal_actions {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 8px;
}

.confirm_modal_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 36px;
    padding: 0 16px;
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

/* keyboard users see where they are: the global stylesheet removes every outline */
.confirm_modal_button:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
}

.confirm_modal_cancel {
    background-color: transparent;
    border: 1px solid var(--border);
    color: var(--text-primary);
}

.confirm_modal_cancel:hover:not(:disabled) {
    background-color: var(--bg);
}

.confirm_modal_confirm {
    background-color: var(--primary);
    border: 1px solid var(--primary);
    color: #fff;
}

.confirm_modal_confirm:hover:not(:disabled) {
    background-color: var(--primary-hover);
    box-shadow: var(--shadow-sm);
}

.confirm_modal_confirm_danger,
.confirm_modal_confirm_danger:hover:not(:disabled) {
    background-color: var(--confirm-danger);
    border-color: var(--confirm-danger);
}

[data-theme="dark"] .confirm_modal_confirm_danger {
    color: #1E293B;
}

.confirm_modal_button:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .confirm_modal {
        flex-direction: column;
    }
}

@media (prefers-reduced-motion: reduce) {
    .confirm_modal_overlay,
    .confirm_modal {
        animation: none;
    }
}

@keyframes confirm_modal_fade {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes confirm_modal_pop {
    from { opacity: 0; transform: translateY(6px) scale(0.98); }
    to { opacity: 1; transform: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmModal/confirmModal.css"],"names":[],"mappings":"AAAA,4FAA4F;;AAE5F;IACI,yBAAyB,EAAE,sDAAsD;IACjF,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;IACjC,kCAA0B;YAA1B,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,gEAAgE;AACpE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,uFAAuF;AAC3F;;AAEA,mFAAmF;AACnF;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA;;IAEI,uCAAuC;IACvC,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,OAAO,UAAU,EAAE,sCAAsC,EAAE;IAC3D,KAAK,UAAU,EAAE,eAAe,EAAE;AACtC","sourcesContent":["/* ===== Confirmation dialog shared by the back-office pages (B-book, notifications) ===== */\n\n.confirm_modal_overlay {\n    --confirm-danger: #B91C1C; /* darker than --danger, so white text reaches 4.5:1 */\n    position: fixed;\n    inset: 0;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px 16px;\n    background: rgba(15, 23, 42, 0.5);\n    backdrop-filter: blur(3px);\n    animation: confirm_modal_fade 0.15s ease-out;\n}\n\n[data-theme=\"dark\"] .confirm_modal_overlay {\n    --confirm-danger: #F87171;\n}\n\n.confirm_modal {\n    display: flex;\n    gap: 16px;\n    width: min(520px, 100%);\n    padding: 24px;\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-lg);\n    animation: confirm_modal_pop 0.18s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.confirm_modal_icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    color: var(--primary);\n    background-color: var(--primary-light);\n}\n\n.confirm_modal_icon_danger {\n    color: var(--confirm-danger);\n    background-color: var(--danger-light);\n}\n\n.confirm_modal_body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    min-width: 0;\n}\n\n.confirm_modal_body h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.confirm_modal_body p {\n    margin: 0;\n    line-height: 1.55;\n    color: var(--text-secondary);\n}\n\n.confirm_modal_actions {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 8px;\n}\n\n.confirm_modal_button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 36px;\n    padding: 0 16px;\n    border-radius: var(--radius-sm);\n    font-size: 14px;\n    font-weight: 600;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n/* keyboard users see where they are: the global stylesheet removes every outline */\n.confirm_modal_button:focus-visible {\n    outline: 2px solid var(--primary);\n    outline-offset: 2px;\n}\n\n.confirm_modal_cancel {\n    background-color: transparent;\n    border: 1px solid var(--border);\n    color: var(--text-primary);\n}\n\n.confirm_modal_cancel:hover:not(:disabled) {\n    background-color: var(--bg);\n}\n\n.confirm_modal_confirm {\n    background-color: var(--primary);\n    border: 1px solid var(--primary);\n    color: #fff;\n}\n\n.confirm_modal_confirm:hover:not(:disabled) {\n    background-color: var(--primary-hover);\n    box-shadow: var(--shadow-sm);\n}\n\n.confirm_modal_confirm_danger,\n.confirm_modal_confirm_danger:hover:not(:disabled) {\n    background-color: var(--confirm-danger);\n    border-color: var(--confirm-danger);\n}\n\n[data-theme=\"dark\"] .confirm_modal_confirm_danger {\n    color: #1E293B;\n}\n\n.confirm_modal_button:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n    .confirm_modal {\n        flex-direction: column;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .confirm_modal_overlay,\n    .confirm_modal {\n        animation: none;\n    }\n}\n\n@keyframes confirm_modal_fade {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes confirm_modal_pop {\n    from { opacity: 0; transform: translateY(6px) scale(0.98); }\n    to { opacity: 1; transform: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
